import OrderListPage from '@pages/OrderListPage/OrderList';
import React from 'react';

export default function Page() {
  return <OrderListPage />;
}
